import * as React from "react";
const ComfortIcon = (props) => (
  <svg
    width={44}
    height={38}
    viewBox="0 0 44 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.875 16.625C7.63439 16.625 8.25 16.0933 8.25 15.4375C8.25 14.7817 7.63439 14.25 6.875 14.25C6.11561 14.25 5.5 14.7817 5.5 15.4375C5.5 16.0933 6.11561 16.625 6.875 16.625Z"
      fill="#1C9CED"
    />
    <path
      d="M15.125 23.75C15.8844 23.75 16.5 23.2183 16.5 22.5625C16.5 21.9067 15.8844 21.375 15.125 21.375C14.3656 21.375 13.75 21.9067 13.75 22.5625C13.75 23.2183 14.3656 23.75 15.125 23.75Z"
      fill="#1C9CED"
    />
    <path
      d="M20.625 30.875C21.3844 30.875 22 30.3433 22 29.6875C22 29.0317 21.3844 28.5 20.625 28.5C19.8656 28.5 19.25 29.0317 19.25 29.6875C19.25 30.3433 19.8656 30.875 20.625 30.875Z"
      fill="#1C9CED"
    />
    <path
      d="M23.375 19C24.1344 19 24.75 18.4683 24.75 17.8125C24.75 17.1567 24.1344 16.625 23.375 16.625C22.6156 16.625 22 17.1567 22 17.8125C22 18.4683 22.6156 19 23.375 19Z"
      fill="#1C9CED"
    />
    <path
      d="M17.875 14.25C18.6344 14.25 19.25 13.7183 19.25 13.0625C19.25 12.4067 18.6344 11.875 17.875 11.875C17.1156 11.875 16.5 12.4067 16.5 13.0625C16.5 13.7183 17.1156 14.25 17.875 14.25Z"
      fill="#1C9CED"
    />
    <path
      d="M12.375 33.25C13.1344 33.25 13.75 32.7183 13.75 32.0625C13.75 31.4067 13.1344 30.875 12.375 30.875C11.6156 30.875 11 31.4067 11 32.0625C11 32.7183 11.6156 33.25 12.375 33.25Z"
      fill="#1C9CED"
    />
    <path
      d="M4.125 26.125C4.88439 26.125 5.5 25.5933 5.5 24.9375C5.5 24.2817 4.88439 23.75 4.125 23.75C3.36561 23.75 2.75 24.2817 2.75 24.9375C2.75 25.5933 3.36561 26.125 4.125 26.125Z"
      fill="#1C9CED"
    />
    <path
      d="M34.375 35.625C32.9333 35.6288 31.5268 35.24 30.3557 34.5139C29.1845 33.7878 28.3082 32.7612 27.8514 31.5802C27.3945 30.3993 27.3804 29.124 27.8111 27.9357C28.2417 26.7474 29.0951 25.7066 30.25 24.9613V17.8125C30.25 16.8677 30.6846 15.9615 31.4582 15.2934C32.2318 14.6253 33.281 14.25 34.375 14.25C35.469 14.25 36.5182 14.6253 37.2918 15.2934C38.0654 15.9615 38.5 16.8677 38.5 17.8125V24.9613C39.6549 25.7066 40.5083 26.7474 40.9389 27.9357C41.3696 29.124 41.3555 30.3993 40.8986 31.5802C40.4418 32.7612 39.5655 33.7878 38.3943 34.5139C37.2232 35.24 35.8167 35.6288 34.375 35.625ZM34.375 16.625C34.0104 16.6253 33.6609 16.7505 33.4031 16.9732C33.1453 17.1958 33.0004 17.4977 33 17.8125V26.2794L32.3166 26.6238C31.6894 26.9312 31.1677 27.3767 30.8047 27.9148C30.4417 28.453 30.2503 29.0647 30.25 29.6875C30.25 30.6323 30.6846 31.5385 31.4582 32.2066C32.2318 32.8747 33.281 33.25 34.375 33.25C35.469 33.25 36.5182 32.8747 37.2918 32.2066C38.0654 31.5385 38.5 30.6323 38.5 29.6875C38.4999 29.0645 38.3087 28.4526 37.9456 27.9142C37.5826 27.3758 37.0608 26.9301 36.4334 26.6226L35.75 26.2794V17.8125C35.7496 17.4977 35.6047 17.1958 35.3469 16.9732C35.0891 16.7505 34.7396 16.6253 34.375 16.625ZM2.75 7.125H41.25V9.5H2.75V7.125Z"
      fill="#1C9CED"
    />
  </svg>
);
export default ComfortIcon;
